(() => {
  if (window.oldtrendShoeInitialized) return;
  window.oldtrendShoeInitialized = true;
  const triggerSelector = '[data-oldtrend-size-chart-open]';
  const closeSelector = '[data-oldtrend-size-chart-close]';
  const marketingSizeSelector = '[data-oldtrend-marketing-size]';
  let activeTrigger = null;

  const selectMarketingSize = (input) => {
    const productPage = input.closest('.product-page');
    if (!productPage) return;
    productPage.classList.add('variant--soldout');

    const selectedValue = input.closest('fieldset')?.querySelector('[data-option-value]');
    if (selectedValue) selectedValue.textContent = input.value;

    const addButton = productPage.querySelector('[data-add-to-cart]');
    const addButtonText = addButton?.querySelector('[data-add-to-cart-text]');
    const soldOutLabel = input.dataset.oldtrendSoldOutLabel || 'Sold Out';

    if (addButton) {
      addButton.disabled = true;
      addButton.setAttribute('aria-label', soldOutLabel);
    }
    if (addButtonText) addButtonText.textContent = soldOutLabel;

    const variantInput = productPage.querySelector('[data-product-form] input[name="id"]');
    if (variantInput) variantInput.value = '';
  };

  const mountDrawers = () => document.querySelectorAll('[data-oldtrend-size-chart]').forEach((drawer) => {
    if (drawer.parentElement === document.body) return;
    const existing = [...document.body.children].find((node) => node.id === drawer.id);
    if (existing) drawer.remove();
    else document.body.appendChild(drawer);
  });
  mountDrawers();
  window.addEventListener('theme:section:update', mountDrawers);
  document.addEventListener('shopify:section:load', mountDrawers);

  const getFocusable = (drawer) => Array.from(
    drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter((element) => element.offsetParent !== null);

  const closeDrawer = (drawer, restoreFocus = true) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oldtrend-size-chart-open');

    document.querySelectorAll(triggerSelector).forEach((trigger) => {
      if (trigger.getAttribute('aria-controls') === drawer.id) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    if (restoreFocus && activeTrigger) activeTrigger.focus();
    activeTrigger = null;
  };

  const openDrawer = (trigger) => {
    mountDrawers();
    const drawerId = trigger.getAttribute('aria-controls');
    const drawer = drawerId ? document.getElementById(drawerId) : null;
    if (!drawer) return;

    activeTrigger = trigger;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('oldtrend-size-chart-open');

    const panel = drawer.querySelector('[data-oldtrend-size-chart-panel]');
    const closeButton = drawer.querySelector('.oldtrend-size-chart__close');
    window.requestAnimationFrame(() => (closeButton || panel)?.focus());
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger) {
      event.preventDefault();
      openDrawer(trigger);
      return;
    }

    const closeControl = event.target.closest(closeSelector);
    if (closeControl) {
      event.preventDefault();
      closeDrawer(closeControl.closest('[data-oldtrend-size-chart]'));
    }
  });

  document.addEventListener('change', (event) => {
    const marketingSize = event.target.closest(marketingSizeSelector);
    if (marketingSize) {
      selectMarketingSize(marketingSize);
      return;
    }

    const shoeSize = event.target.closest('.oldtrend-size-chart-fieldset input[type="radio"]');
    shoeSize?.closest('.product-page')?.classList.remove('variant--soldout');
  });

  document.addEventListener('keydown', (event) => {
    const drawer = document.querySelector('[data-oldtrend-size-chart].is-open');
    if (!drawer) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(drawer);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusable(drawer);
    if (!focusable.length) {
      event.preventDefault();
      drawer.querySelector('[data-oldtrend-size-chart-panel]')?.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
